export default __webpack_public_path__ + "static/media/passport-ok.b0d67719.jpg";